import { navigate } from "gatsby"
import { search as trackSearch } from "~utils/analytics"

class Engine {
  constructor({ microcopy, state }) {
    this.state = state[0]
    this.setState = state[1]

    this.microcopy = microcopy
    this.code = microcopy ? microcopy.code : "en"
    this.false = this.code === "ja" ? "no" : "false"
  }

  // Show the search button
  showButton() {
    this.updateState({ showSearchButton: true })
  }

  // Show the search box
  async show() {
    this.updateState({ showSearch: true })
  }

  // toggle the search button
  async toggle() {
    if (!this.state.showSearch) {
      this.updateState({ query: "" })
    }
    this.updateState({ showSearch: !this.state.showSearch })
  }

  // Smart update the state
  updateState(object) {
    this.setState((state) => ({ ...state, ...object }))
  }

  // Set the result list fucus state
  onResultFocusChange(isFocused) {
    this.updateState({ isResultFocused: isFocused })
  }

  // Get the selected item index
  getSelectedItemIndex = () => this.state.selected

  /**
   * Perform a lunr search
   */
  search(value) {
    this.updateState({ query: value })
    const lunr = window.__LUNR__[this.code]

    // scroll back to the top
    this.updateState({ selected: 0 })

    // get the query term
    const query = value.trim().toLowerCase().replace(/[*:]/gi, " ").trim()

    // if no query or search found, reset the result
    if (!query || query.length === 0 || !lunr) return this.updateState({ results: [] })

    // perform the query
    const results = lunr.index
      .search(`${query}* ${this.priority()}`)
      .slice(0, 400)
      .map((result) => this.dereference(lunr, result))
      .reduce(promoteExactMatches(query), [[], []])
      .filter(({ score }, index) => index < 10 || score > 100)
      .slice(0, 40)
      .flatMap((item) => item)

    // set the results
    this.updateState({ results })
    // finally, track the search
    trackSearch(value)
  }

  priority() {
    return Object.entries(this.state.filters)
      .filter(([_, value]) => value === false)
      .map(([key]) => `+is${key}:${this.false}`)
      .join(" ")
  }

  dereference(lunr, { ref, score }) {
    return { ref, score, ...lunr.store[ref] }
  }

  /**
   * Handle non-standard key-ups in the inout field
   */
  keyup(event) {
    // hide on escape, directly
    if (event.keyCode === 27) this.hide(0)
    // only handle the following if the result list has focus
    if (this.state.isResultFocused) {
      // select the next item
      if (event.keyCode === 40) this.selectNextResult()
      // // select the previous item
      if (event.keyCode === 38) this.selectPreviousResult()
      // navigate to a path
      if (event.keyCode === 13) {
        this.navigate(this.state.results[this.state.selected].path)
        this.hide(200)
      }
    }
  }

  selectNextResult() {
    this.setState((state) => {
      const selected = Math.min(state.selected + 1, state.results.length - 1)
      return { ...state, ...{ selected } }
    })
  }

  selectPreviousResult() {
    this.setState((state) => {
      const selected = Math.max(state.selected - 1, 0)
      return { ...state, ...{ selected } }
    })
  }

  /**
   * Navigate to a path
   */
  navigate(path) {
    // hide if we are at this path
    if (
      typeof window !== "undefined"
      && window
      && window.location.pathname === path
    ) {
      this.hide()
    }
    navigate(path)
    this.hide()
  }

  /**
   * Hides the search UI with a small delay
   * in order to allow navigation to complete.
   */
  hide(timeout = 0) {
    setTimeout(() => {
      this.updateState({ results: [], showSearch: false })
    }, timeout)
  }

  filter(filterType, filterState) {
    this.setState((state) => {
      state.filters[filterType] = filterState
      return state
    })

    if (this.state.query) {
      setTimeout(() => this.search(this.state.query), 0)
    }
  }
}

const promoteExactMatches = (query) => (lists, result) => {
  result.title.toLowerCase().startsWith(query)
    ? lists[0].push(result)
    : lists[1].push(result)
  return lists
}

export default Engine
